import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { RecipientRow } from '../ui/collections/Recipient';
import RecipientNameChip from './select/chips/RecipientName';
import FilteredMultiSelect from './FilteredMultiSelect';

function MultiRecipientSelect({ placeholder, excludeValues, ...props }) {
  const { t } = useTranslation(['commonPlat']);
  return (
    <FilteredMultiSelect
      {...props}
      placeholder={placeholder || t('commonPlat:placeholders.multiRecipientSelect')}
      optionRenderer={RecipientRow}
      selectedRenderer={RecipientNameChip}
      searchKey={'label'}
      primaryKey="targetRel"
      excludeKey="targetRel"
      excludeValues={excludeValues}
    />
  );
}

MultiRecipientSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  excludeValues: PropTypes.arrayOf(PropTypes.object),
};

MultiRecipientSelect._hookable = true;

export default MultiRecipientSelect;
